export enum ConversationArchiveReasonEnum {
  Manual = 'MANUAL',
  MissingEmail = 'MISSING_EMAIL',
}
